export const USER_PRIVILEGE = {
  SUPERVISOR: 'supervisor',
  ADMIN: 'admin',
  STANDARD: 'standard',
  SIGNAGE: 'signage',
};

export const USER_PRIVILEGE_KEY = 'user-privilege';
export const USER_ID_KEY = 'user-id';
